import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Car Sales Service
 * Araç rezervasyon akışı API'leri için servis
 */
export const carSalesService = {
  /**
   * Car allocation
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  allocateCar: (payload = {}, headers = {}, hasErrorHandler = false) => {
    const finalPayload = {
      AllocateForm: payload,
      ConstructLocalizationKeys: true,
    };

    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.sales.allocateCar,
      payload: finalPayload,
      headers,
      hasErrorHandler,
    });
  },

  /**
   * Car allocation
   * @param {Object} payload - API payload
   * @param {string} payload.Language - Dil kodu (örn: "tr", "en")
   * @param {string} payload.BasketId
   * @param {string} payload.CarProductId
   * @param {string} payload.Driver
   * @param {Object} headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  prebookCar: (payload = {}, headers = {}, hasErrorHandler = false) => {
    const finalPayload = {
      ...payload,
      ConstructLocalizationKeys: true,
    };

    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.sales.prebook,
      payload: finalPayload,
      headers,
      hasErrorHandler,
    });
  },

  /**
   * Sepet bilgilerini getir (Get Basket)
   * @param {Object} payload - İstek gövdesi
   * @param {number} payload.BasketId - Sepet ID'si
   * @param {Object} [payload.BookingCode] - Rezervasyon kodu (opsiyonel)
   * @param {string} [payload.BookingCode.Code] - Rezervasyon kodu
   * @param {string} [payload.BookingCode.LastName] - Soyadı
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {number} payload.AppVersion - Uygulama versiyonu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Usage Example:
   * getBasket({
   *   BasketId: 123,
   *   LanguageCode: "tr",
   *   AppVersion: 0
   * })
   * → POST /v1/bus/sales/getbasket
   *
   * Usage Example with BookingCode:
   * getBasket({
   *   BasketId: 123
   * })
   * → POST /v2/flight/ticketing/GetActiveBasket
   */
  getBasket: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.sales.getBasket,
      payload,
      headers,
      hasErrorHandler,
    });
  },
};
